import React from "react";
import "../styles/ResumeTips.css";

const ResumeTips = () => {
  return (
    <div className="resume-tips-page">
      <h1>📄 How to Build a Job-Winning Resume?</h1>
      <p>Stand out in the competitive job market with a well-crafted resume.</p>

      <section className="resume-section">
        <h2>✨ Key Elements of a Winning Resume</h2>
        <ul>
          <li><strong>Clear Contact Information:</strong> Include your name, email, LinkedIn, and phone number.</li>
          <li><strong>Professional Summary:</strong> A 2-3 sentence summary highlighting your experience and skills.</li>
          <li><strong>Work Experience:</strong> Use bullet points with achievements and impact (not just responsibilities).</li>
          <li><strong>Skills Section:</strong> Highlight relevant technical and soft skills.</li>
          <li><strong>Projects:</strong> Showcase impactful projects with links to GitHub or live demos.</li>
          <li><strong>Education & Certifications:</strong> Include relevant degrees, courses, and certifications.</li>
        </ul>
      </section>

      <section className="resume-examples">
        <h2>📌 Resume Templates & Examples</h2>
        <p>Download free resume templates tailored for software engineers, data analysts, and product managers.</p>
        <a href="/resume-templates" className="btn primary-btn">Download Templates</a>
      </section>

      <section className="resume-cta">
        <h2>📝 Get a Free Resume Review!</h2>
        <p>Upload your resume, and our experts will review it for free.</p>
        <button className="btn secondary-btn">Upload Resume</button>
      </section>
    </div>
  );
};

export default ResumeTips;
